import HTTP from "@/_helpers/http";
import { COMMISSIONTREE__API } from "@/_helpers/urls";
import { COMMISSIONTREE__MUTATIONS } from "../mutation-types";
import { COMMISSIONTREE__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
    levelCounts: 0,
    tierCounts: 0,
    accountTypes: null,
    currencyGroups: null,
    splited_data: null,
    addcommissionconfig: null,
    allcommissiontrees: null,
    viewcommission: null,
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [COMMISSIONTREE__MUTATIONS.GETCOMMISSIONSETTINGS](state, data) {
        state.levelCounts = data.levelCounts;
        state.accountTypes = data.accountTypes;
        state.currencyGroups = data.currencyGroups;
        state.tierCounts = data.tierCounts;
    },
    [COMMISSIONTREE__MUTATIONS.SPLITTOTALCOMMISSION](state, data) {
        state.splited_data = data.splited_data;
    },
    [COMMISSIONTREE__MUTATIONS.ADDCOMMISSIONSETTINGSCONFIG](state, data) {
        state.addcommissionconfig = data.addcommissionconfig;
    },
    [COMMISSIONTREE__MUTATIONS.ALLCOMMISSIONTREES](state, data) {
        state.allcommissiontrees = data;
    },
    [COMMISSIONTREE__MUTATIONS.VIEWCOMMISSION](state, data) {
        state.viewcommission = data;
    },
};
// Actions
const actions = {
    async [COMMISSIONTREE__ACTIONS.UPDATECOMMISSIONTREE]({ commit, state, dispatch }, data) {
        try {
            const response = await HTTP().post(
                COMMISSIONTREE__API.UPDATECOMMISSIONTREE, data
            );

            dispatch(COMMISSIONTREE__ACTIONS.ALLCOMMISSIONTREES);
            toast.success(response.data.message)
        } catch (error) {
            console.log(error);
            toast.error('Failed to update')
        }
    },
    async [COMMISSIONTREE__ACTIONS.GETCOMMISSIONSETTINGS]({ commit, state }) {
        try {
            const response = await HTTP().get(
                COMMISSIONTREE__API.GETCOMMISSIONSETTINGS
            );

            if (response.status === 200) {
                commit(COMMISSIONTREE__MUTATIONS.GETCOMMISSIONSETTINGS, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [COMMISSIONTREE__ACTIONS.ADDCOMMISSIONSETTINGSCONFIG]({ commit, state }) {
        try {
            const response = await HTTP().get(
                COMMISSIONTREE__API.ADDCOMMISSIONSETTINGSCONFIG
            );

            if (response.status === 200) {
                commit(COMMISSIONTREE__MUTATIONS.ADDCOMMISSIONSETTINGSCONFIG, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [COMMISSIONTREE__ACTIONS.VIEWCOMMISSION]({ commit, state }, parameter) {
        try {
            const account_typeParam = parameter?.account_type != null ? `account_type=${parameter.account_type}` : "";
            const currency_groupParam = parameter?.currency_group != null ? `currency_group=${parameter.currency_group}` : "";

            const parameterString = [
                account_typeParam,
                currency_groupParam
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                COMMISSIONTREE__API.VIEWCOMMISSION +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(COMMISSIONTREE__MUTATIONS.VIEWCOMMISSION, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [COMMISSIONTREE__ACTIONS.SPLITTOTALCOMMISSION]({ commit, state }, parameter) {
        try {
            const totalCommissionParam = parameter?.totalCommission != null ? `totalCommission=${parameter.totalCommission}` : "";
            const finalLevelParam = parameter?.finalLevel != null ? `finalLevel=${parameter.finalLevel}` : "";

            const parameterString = [
                totalCommissionParam,
                finalLevelParam
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                COMMISSIONTREE__API.SPLITTOTALCOMMISSION +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(COMMISSIONTREE__MUTATIONS.SPLITTOTALCOMMISSION, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [COMMISSIONTREE__ACTIONS.ALLCOMMISSIONTREES]({ commit, state }, parameter) {
        try {
            const atParam = parameter?.account_type != null ? `account_type=${parameter.account_type}` : "";
            const cgParam = parameter?.currency_group != null ? `currency_group=${parameter.currency_group}` : "";

            const parameterString = [
                atParam,
                cgParam
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                COMMISSIONTREE__API.ALLCOMMISSIONTREES +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(COMMISSIONTREE__MUTATIONS.ALLCOMMISSIONTREES, response.data);
                return
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [COMMISSIONTREE__ACTIONS.ADDCOMMISSIONTREE](
        { commit, state, dispatch },
        parameter
    ) {
        try {
            const response = await HTTP().post(
                COMMISSIONTREE__API.ADDCOMMISSIONTREE,
                parameter
            );

            if (response.status === 200) {
                dispatch(COMMISSIONTREE__ACTIONS.ALLCOMMISSIONTREES)
                toast.success(response.data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
